import * as React from 'react'
import { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { makeStyles, Text, tokens } from '@fluentui/react-components'

export type LabelValueProps = {
    label?: ReactNode
    value?: ReactNode
}

const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
    },
    label: {
        color: tokens.colorNeutralForeground3,
    },
})

/**
 * v9 label + value pair used inside the v9 DiagnosticsDialog. Renders nothing when there is no value/children,
 * mirroring the legacy (Fluent-v8) LabelValue behaviour.
 */
export default function LabelValue(props: PropsWithChildren<LabelValueProps>): ReactElement {
    const styles = useStyles()

    if ((props.value === undefined || props.value === null || props.value === '') && !props.children) {
        return <></>
    }

    return (
        <div className={styles.wrapper}>
            {props.label && (
                <Text size={200} className={styles.label}>
                    {props.label}
                </Text>
            )}
            <Text>{props.value ?? props.children}</Text>
        </div>
    )
}
